import React from "react";

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 110">
      <g data-name="Layer 2">
        <path fill="none" d="M0 0h150v110H0z" data-name="Rectangle 15168" />
        <g data-name="Group 1417">
          <g data-name="Group 1411">
            <g
              fill="none"
              stroke="#424242"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
              data-name="Group 1403"
            >
              <path
                d="M75 58.69a6.93 6.93 0 014.7 1.83h0l8.42 7.65h0A6.93 6.93 0 0099.73 63V50.88A10.84 10.84 0 0088.89 40H61.11a10.84 10.84 0 00-10.84 10.88V63a6.94 6.94 0 0011.59 5.15h0l8.42-7.65h0A6.93 6.93 0 0175 58.69z"
                data-name="Path 1185"
              />
              <path d="M61.33 46.32v9.55" data-name="Line 92" />
              <path d="M66.1 51.09h-9.54" data-name="Line 93" />
              <circle cx="88.34" cy="47.41" r="1.09" data-name="Ellipse 16" />
              <circle cx="88.34" cy="54.78" r="1.09" data-name="Ellipse 17" />
              <circle cx="92.03" cy="51.1" r="1.09" data-name="Ellipse 18" />
              <circle cx="84.65" cy="51.1" r="1.09" data-name="Ellipse 19" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default Icon;
